// Public asset URLs for brand assets
export const RHEEL_LOGO_URL = "/brand/rheel-logo-full.png";
// Backwards-compat alias (legacy imports across the codebase)
export const MISCO_LOGO_URL = RHEEL_LOGO_URL;
